import { useMemo } from 'react';
import { orderList } from '../../../utils';

const Filters = (vm) => {
  const filteredActivities = useMemo(() => {
    const q = vm.query.trim().toLowerCase();
    let sortedActivities = vm.activities;
    if (q) {
      sortedActivities = vm.activities.filter((activity) => {
        const nombre = `${activity.Name ?? ''}`.toLowerCase();
        return nombre.includes(q);
      });
    }
    return orderList(sortedActivities, vm.sortConfig);
  }, [vm.activities, vm.query, vm.sortConfig]);

  const handleSort = async (column) => {
    const lostAccess = await vm.losesAccess?.();
    if (lostAccess) return;
    vm.setSortConfig((prevConfig) => {
      const newDirection =
        prevConfig.column === column && prevConfig.direction === 'asc'
          ? 'desc'
          : 'asc';
      return {
        column,
        direction: newDirection,
      };
    });
  };

  return {
    filteredActivities,
    handleSort,
  };
};

export default Filters;
